<template>
    <div>
        <quillEditor
            :content="description"
            :options="editorOption"
            @change="onEditorChange($event)"
            class="roma-editor"
        >
        </quillEditor>
    </div>
</template>

<script>
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";

import { quillEditor } from "vue-quill-editor";
export default {
    props: {
        placeholder: {
            type: String
        },
        data: {},
        updateMode: {
            type: Object
        }
    },
    data() {
        return {
            editorOption: {
                placeholder: this.placeholder
                    ? this.placeholder
                    : ""
            },
            description: this.updateMode.status
                ? this.updateMode.currentSelected
                : ""
        };
    },
    components: {
        quillEditor
    },
    methods: {
        onEditorChange({ html }) {
            this.data(html);
        }
    }
};
</script>

<style lang="scss">
.roma-editor {
    border-radius: 10px;
    border: 1px solid rgba(black, 0.2);
    display: flex;
    flex-direction: column-reverse;
    .ql-formats {
        .ql-link,
        .ql-video,
        .ql-image,
        .ql-font {
            display: none;
        }
    }
    // overflow: hidden;
    .ql-editor {
        padding: 1.5rem;
        &.ql-blank::before {
            left: 1.5rem;
        }
    }
    .ql-toolbar {
        background-color: #f5f5f5 !important;
        display: flex;
        flex-wrap: wrap;
        justify-content: flex-end;
        // border-radius: 28px;
        border-bottom-left-radius: 10px;
        border-bottom-right-radius: 10px;
    }
    .ql-container {
        height: auto;
    }
    .ql-toolbar,
    .ql-container {
        border: 0;
    }
}
.custom-wyswyg {
    height: 200px;
    .v-card {
        height: 100%;
        border-radius: 28px !important;
        display: flex;
        flex-direction: column-reverse;
        overflow: hidden;
        .v-toolbar {
            justify-content: flex-end;
        }
        .tiptap-vuetify-editor__content {
            flex: 1;
        }
    }
}
</style>